import * as React from 'react';
import { Icon } from 'semantic-ui-react';
import * as InfoCardApi from '~/Api/InfoCard';
import { formatUserMonthYear } from '~/Date';
import { resolveIconName } from './Tag';
var resolveActionTagName = function (tag) {
    switch (tag.type) {
        case InfoCardApi.TagType.brand:
            return (<>
					se týkají výrobce <strong data-testid='action-tag-value'>{tag.title}</strong>
				</>);
        case InfoCardApi.TagType.market:
            return (<>
					jsou z trhu <strong data-testid='action-tag-value'>{tag.title}</strong>
				</>);
        case InfoCardApi.TagType.source:
            return (<>
					pochází ze zdroje <strong data-testid='action-tag-value'>{tag.title}</strong>
				</>);
        case InfoCardApi.TagType.type:
            return (<>
					se týkají tématu <strong data-testid='action-tag-value'>{tag.title}</strong>
				</>);
        case InfoCardApi.TagType.yearMonth:
            return (<>
					jsou z měsíce <strong data-testid='action-tag-value'>{formatUserMonthYear(tag.date, ['cs-CZ'])}</strong>
				</>);
        default:
            return null;
    }
};
export var ActionMenuTag = function (_a) {
    var tag = _a.tag;
    return (<>
		<Icon name={resolveIconName(tag.type)}/>
		{resolveActionTagName(tag)}
	</>);
};
export var TagLink = function (_a) {
    var InfoCardsLink = _a.InfoCardsLink, tag = _a.tag;
    return (<InfoCardsLink tag={tag}>
		<a className='descriptionItem' data-testid={"".concat(tag.type, "-tag")}>
			<ActionMenuTag tag={tag}/>
		</a>
	</InfoCardsLink>);
};
